import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import {
  errors,
  IPassengerInfo,
  IRideDto,
  IRideUpdateResultDto,
  RideSoftValidationErrorResponse,
  SimpleResult,
} from "@ryde/shared";

import { useDragRidesPassengers } from "./use-drag-rides-passengers";

export const useDragPassengersCreateRide = () => {
  const { t } = useTranslation();
  const { dropPassengersToRide } = useDragRidesPassengers();

  const dragPassengersCreateRide = useEvent(
    async (
      passengerInfos: IPassengerInfo[] | undefined,
      rideFrom: Partial<IRideDto>,
    ): Promise<
      SimpleResult<
        IRideUpdateResultDto | RideSoftValidationErrorResponse | undefined
      >
    > => {
      if (!rideFrom.id) {
        return new SimpleResult({
          error: t(errors.ride.invalidDragRideData),
        });
      }

      if (!passengerInfos?.length) {
        return new SimpleResult({
          error: t(errors.ride.invalidDragDropRideDataNoPassengersToDrop),
        });
      }

      return dropPassengersToRide([...passengerInfos], rideFrom);
    },
  );
  return { dragPassengersCreateRide };
};
